import { render, staticRenderFns } from "./RelationshipsPage.vue?vue&type=template&id=12dfce52"
import script from "./RelationshipsPage.vue?vue&type=script&lang=ts"
export * from "./RelationshipsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports